
(function (doc, win) {
  var docEl = doc.documentElement,
  resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
  recalc = function () {
    docEl.setAttribute('data-dpr', win.devicePixelRatio);
    var clientWidth = docEl.clientWidth;
    clientWidth = clientWidth > 540 ? 540 :clientWidth;
    docEl.style.width = clientWidth  + "px";
    docEl.style.height = docEl.clientHeight  + "px";
    if (!clientWidth) return;
    docEl.style.fontSize = (clientWidth / 10) + 'px';
  };

  if (!doc.addEventListener) return;
  win.addEventListener(resizeEvt, recalc, false);
  doc.addEventListener('DOMContentLoaded', recalc, false);
})(document, window);





// WEBPACK FOOTER //
// ./src/assets/js/adaptation.js